module.exports = __webpack_public_path__ + "927a1bac8bfec452df6b4594579eeab2.png";